// src/components/shell/TopBar.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import PrimaryNav from './PrimaryNav';
import GlobalSearch from './GlobalSearch';
import WorkspaceSwitcher from './WorkspaceSwitcher';
import AccountMenu from './AccountMenu';
import { MoonIcon, SunIcon } from './icons';

export default function TopBar() {
    const { resolvedTheme, toggleTheme } = useTheme();
    const next = resolvedTheme === 'dark' ? 'light' : 'dark';

    return (
        <header className="qd-topbar">
            <div className="qd-topbar__start">
                <Link to="/" className="qd-brand" aria-label="QDex home">
                    <span className="qd-brand__mark" aria-hidden="true">Q</span>
                    <span className="qd-brand__name" aria-hidden="true">QDex</span>
                </Link>
                <span className="qd-topbar__divider" aria-hidden="true" />
                <WorkspaceSwitcher />
            </div>

            <PrimaryNav />

            <GlobalSearch />

            <div className="qd-topbar__end">
                <button
                    type="button"
                    className="qd-icon-btn"
                    onClick={toggleTheme}
                    aria-label={`Switch to ${next} theme`}
                    title={`Switch to ${next} theme`}
                >
                    {resolvedTheme === 'dark' ? <SunIcon size={18} /> : <MoonIcon size={18} />}
                </button>
                <AccountMenu />
            </div>
        </header>
    );
}
